import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiRequest } from "@core/services/api/apiRequest";
import type { Organization, OrganizationUpdateData } from "../organization.types";

type Args = {
  organizationId: number;
  onSuccess?: (data: Organization) => void;
};

/**
 * Mutation hook to update organization profile.
 */
export function useUpdateOrganization({ organizationId, onSuccess }: Args) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: OrganizationUpdateData) => {
      return await apiRequest(
        `/organization/${organizationId}/update/`,
        "POST",
        data
      ) as Organization;
    },
    onSuccess: async (data) => {
      await queryClient.invalidateQueries({
        queryKey: ["organization", organizationId],
      });
      onSuccess?.(data);
    },
  });
}

